import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/gastrohub/locations/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) =>
        api.get(`/gastrohub/locations`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/gastrohub/locations/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/gastrohub/locations`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/gastrohub/locations/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/gastrohub/locations/${url.id}`, data, config),
};

export default requests;
